import React from "react";
import { useRef } from "react";
import "./Collaboration.css";

function Collaboration({ isActiveCollaboration, scrollItem, onScrollItem }) {
  const collaborationRef = useRef();

  React.useEffect(()=>{
    if (scrollItem === "collaboration") {
      onScrollItem(collaborationRef);
    }
  },[onScrollItem,scrollItem])

  return (
    <section ref={collaborationRef} className={`collaboration page__container inactive ${isActiveCollaboration ? "active" : ""}`}>
      <h2 className="collaboration__title">Порядок сотрудничества</h2>
      <ul className="collaboration__cards">
        <li className="collaboration__card">
          <div className="collaboration__circle"></div>
          <h3 className="collaboration__card-title">1 Этап</h3>
          <p className="collaboration__card-text">Анализ электрохозяйства потребителя</p>
        </li> 
        <li className="collaboration__card">
          <div className="collaboration__circle"></div>
          <h3 className="collaboration__card-title">2 Этап</h3>
          <p className="collaboration__card-text">Установление договорных отношений с потребителем</p>
        </li>
        <li className="collaboration__card">
          <div className="collaboration__circle"></div>
          <h3 className="collaboration__card-title">3 Этап</h3>
          <p className="collaboration__card-text">Установление договорных отношений с сетевыми организациями</p>
        </li>
        <li className="collaboration__card">
          <div className="collaboration__circle"></div>
          <h3 className="collaboration__card-title">4 Этап</h3>
          <p className="collaboration__card-text">Создание (модернизация) АИИС КУЭ</p>

        </li>
        <li className="collaboration__card">
          <div className="collaboration__circle"></div>
          <h3 className="collaboration__card-title">5 Этап</h3>
          <p className="collaboration__card-text">Подготовка документации для получения права торговли на ОРЭМ</p>
        </li>
        <li className="collaboration__card">
          <div className="collaboration__circle"></div>
          <h3 className="collaboration__card-title">6 Этап</h3>
          <p className="collaboration__card-text">Поставка электроэнергии с ОРЭМ через 4-6 месяцев от начала сотрудничества</p>
        </li>
      </ul>
    </section>
  );
}

export default Collaboration;
